<template>
    <el-autocomplete
        v-model="name"
        :fetch-suggestions="UserSearch"
        :trigger-on-focus="false"
        @select="UserSelect"
        @clear="UserClear"
        @input="UserInput"
        size="mini"
        value-key="name"
        clearable
        placeholder="成员:例如'许XX''" >
    </el-autocomplete>
</template>
<script>
export default {
    props: {
        value: {
            type: Number,
            default: null
        }
    },
    data () {
        return {
            name: null,
            id: null,
            role: null,
        }
    },
    methods: {
        UserSearch(queryString, callback) {
            if (queryString) {
                this.$http.post('/9api/users/search', { search: { name: queryString } }).then(rps => {
                    callback(rps.data.data)
                })
            }
        },
        UserSelect(item) {
            this.id = item.id
            this.$emit('input', item.id)
            this.$emit('onChange', item)
        },
        UserClear() {
            this.id = null
            this.$emit('input', null)
            this.$emit('onChange', null)
        },
        UserInput() {
            if (this.name.length == 0 && this.id != null) {
                this.id = null
                this.$emit('input', null)
                this.$emit('onChange', null)
            }
        }
    }
}
</script>